// ============================================================================
// FshijLlogarine.jsx — faqja publike e fshirjes së llogarisë. Rruga: /fshij-llogarine
//
// 29 gusht 2026. E kërkuar nga GOOGLE PLAY, jo nga ne.
//
// ─────────────────────────────────────────────────────────────────────────────
// PSE EKZISTON
//
// Fshirja e llogarisë ekzistonte tashmë BRENDA aplikacionit, dhe kjo mjafton
// për Apple. Google kërkon diçka tjetër: një faqe web ku dikush mund ta kërkojë
// fshirjen PA e instaluar aplikacionin. Pa këtë URL, formulari «Data safety»
// nuk mbyllet dot dhe prodhimi bllokohet.
//
// Kërkesa është e arsyeshme: dikush që e ka çinstaluar aplikacionin, ose që e
// ka ndërruar telefonin, nuk duhet ta riinstalojë atë vetëm për të ikur.
//
// ─────────────────────────────────────────────────────────────────────────────
// ASNJË DERË E RE
//
// Kjo faqe NUK shton asnjë funksion serveri. Thërret pikërisht të dyja ato që
// përdor aplikacioni:
//
//   rpc_my_account_delete_check()  — a mundet kjo llogari të fshihet?
//   rpc_delete_my_account()        — fshije
//
// Të dyja janë `security definer` me `auth.uid()`, pra pa sesion nuk bëjnë
// asgjë. Kjo është e rëndësishme: një faqe publike fshirjeje është pikërisht
// vendi ku një derë e re, e shkruar me nxitim para lansimit, do të ishte
// katastrofë. Këtu s'ka derë të re për të gabuar.
//
// ─────────────────────────────────────────────────────────────────────────────
// TRI MBROJTJET, TË NJËJTAT SI TE APLIKACIONI
//
//   1. Fjala «FSHIJ» shkruhet me dorë. Asgjë nuk fshihet me një klikim.
//   2. Rivërtetimi: fjalëkalimi, ose — për ata që hyjnë me Google/Apple dhe
//      s'kanë fjalëkalim — email-i i llogarisë i shkruar saktësisht.
//   3. Admini i fundit i një familjeje bllokohet. Përndryshe një familje e
//      tërë do të mbetej pa askënd që e drejton, dhe askush s'do ta merrte
//      vesh derisa dikujt t'i duhej diçka.
//
// Mbrojtja 2 nuk është teatër: pa të, kushdo që gjen një telefon të shkyçur e
// fshin llogarinë e pronarit nga kjo faqe.
//
// ─────────────────────────────────────────────────────────────────────────────
// GJUHA
//
// Shqip, si motrat e saj `PrivacyPolicy.jsx` dhe `TermsOfService.jsx`. Por me
// një përmbledhje angleze në fund — sepse lexuesi i parë i kësaj faqeje nuk
// është një familjar, është një rishikues i Google-it që nuk di shqip. Një faqe
// pajtueshmërie që rishikuesi nuk e kupton nuk e kryen punën e vet.
// ============================================================================

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { supabase } from "./supabaseClient";

const KONTAKTI = "kontakt@pemaefamiljes.com";

export default function FshijLlogarine() {
  // 4 shtator 2026 — kjo faqe kërkohet nga të dy dyqanet dhe lexohet nga
  // rishikuesit e tyre. Ishte krejt shqip, me një përmbledhje angleze poshtë
  // si arnë. Tani vetë faqja përkthehet, dhe përmbledhja angleze shfaqet VETËM
  // kur gjuha s'është anglisht — ndryshe do të lexohej dy herë e njëjta gjë.
  const { t, i18n } = useTranslation();
  const anglisht = String(i18n.language || "").toLowerCase().startsWith("en");
  const [session, setSession] = useState(null);
  const [duke, setDuke] = useState(true);
  const [info, setInfo] = useState(null);        // {person_count, blocking_families}
  const [fjala, setFjala] = useState("");
  const [sekreti, setSekreti] = useState("");
  const [busy, setBusy] = useState(false);
  const [mesazhi, setMesazhi] = useState("");
  const [ubë, setUbë] = useState(false);

  useEffect(() => {
    let gjallë = true;
    (async () => {
      try {
        const { data } = await supabase.auth.getSession();
        if (!gjallë) return;
        setSession(data?.session || null);
        if (data?.session) {
          // Kontrolli paraprak: paralajmërimi tregohet PARA se dikush të shkruajë
          // «FSHIJ», jo pasi shtyp butonin dhe merr një refuzim pa shpjegim.
          const { data: rows, error } = await supabase.rpc("rpc_my_account_delete_check");
          if (gjallë && !error) setInfo(Array.isArray(rows) ? rows[0] : rows);
        }
      } catch (_e) { /* pa rrjet — faqja mbetet e lexueshme, që është gjysma e punës */ }
      if (gjallë) setDuke(false);
    })();
    return () => { gjallë = false; };
  }, []);

  const email = (session?.user?.email || "").trim().toLowerCase();
  // Kush ka hyrë vetëm me Google/Apple s'ka fjalëkalim për të rivërtetuar —
  // atëherë provë bëhet shkrimi i saktë i email-it.
  const providers = (session?.user?.identities || []).map((i) => i.provider);
  const kaFjalekalim = providers.length === 0 || providers.includes("email");
  const bllokuar = Array.isArray(info?.blocking_families) && info.blocking_families.length > 0;
  const gati = fjala.trim().toUpperCase() === "FSHIJ" && sekreti.trim() && !bllokuar && !busy;

  const fshij = async () => {
    setMesazhi("");
    if (fjala.trim().toUpperCase() !== "FSHIJ") { setMesazhi(t("Type DELETE to confirm.")); return; }
    setBusy(true);
    try {
      if (kaFjalekalim) {
        const { error } = await supabase.auth.signInWithPassword({ email, password: sekreti });
        if (error) { setMesazhi(t("The password is not correct.")); return; }
      } else if (sekreti.trim().toLowerCase() !== email) {
        setMesazhi(t("Type the account email exactly.")); return;
      }
      const { error } = await supabase.rpc("rpc_delete_my_account");
      if (error) { setMesazhi(error.message); return; }
      try { await supabase.auth.signOut(); } catch (_e) { /* llogaria s'ekziston më */ }
      try { localStorage.clear(); sessionStorage.clear(); } catch (_e) { /* asgjë */ }
      setUbë(true);
    } finally { setBusy(false); }
  };

  return (
    <div style={F.faqja}>
      <h1 style={F.titulli}>{t("Deleting your account")}</h1>
      <p style={F.nen}>Pema e Familjes · pemaefamiljes.com</p>

      <Seksioni titulli={t("What is deleted")}>
        {t("Your sign-in (email, password, the link with Google or Apple), the contact details you added for yourself, the legacy messages you wrote, and your notification settings. This cannot be undone.")}
      </Seksioni>

      <Seksioni titulli={t("What stays, and why")}>
        {t("Your place in the family tree stays. Relatives keep seeing you there — but nobody can sign in as you any more.")}
        <br /><br />
        {t("This is deliberate. A family tree is shared: your name, your date of birth and your link to your parents and children are at the same time the history of ten other people. Deleting them would not delete an account — it would remove a link from the family's history. If you also want to be removed from the tree, your family administrator does that.")}
      </Seksioni>

      <Seksioni titulli={t("How it is done")}>
        {t("Sign in with your account below and complete the form. The same thing can be done inside the app:")} <b>{t("My profile → Delete my account")}</b>.
        <br /><br />
        {t("If you cannot sign in — you lost access to the email, or the app will not let you — write to")} <a href={`mailto:${KONTAKTI}?subject=${encodeURIComponent(t("Account deletion request"))}`} style={F.lidhja}>{KONTAKTI}</a> {t("from the account address. The request is completed within 30 days.")}
      </Seksioni>

      <div style={F.kutia}>
        {duke && <p style={F.gri}>{t("Checking…")}</p>}

        {!duke && ubë && (
          <>
            <h2 style={F.h2}>{t("The account has been deleted.")}</h2>
            <p style={F.gri}>{t("You can no longer sign in with it. Thank you for being here.")}</p>
          </>
        )}

        {!duke && !ubë && !session && (
          <>
            <h2 style={F.h2}>{t("Sign in to continue")}</h2>
            <p style={F.gri}>
              Fshirja kërkon që të vërtetosh se je ti. Hap aplikacionin, hyr, dhe
              kthehu te kjo faqe — ose bëje drejt e aty, te <b>Profili im</b>.
            </p>
            <a href="/" style={F.butoniGri}>{t("Open Pema e Familjes")}</a>
          </>
        )}

        {!duke && !ubë && session && (
          <>
            <h2 style={F.h2}>{t("Delete the account {{email}}", { email })}</h2>

            {bllokuar && (
              <div style={F.paralajmerimi}>
                {t("You are the last administrator of:")} <b>{info.blocking_families.join(", ")}</b>.
                <br />{t("Appoint another administrator first — otherwise the family would be left with nobody running it.")}
              </div>
            )}

            <label style={F.etiketa}>{t("Type DELETE to confirm")}</label>
            <input value={fjala} onChange={(e) => setFjala(e.target.value)}
              autoCapitalize="characters" style={F.input} placeholder={t("DELETE")} />

            <label style={F.etiketa}>{kaFjalekalim ? t("Your password") : t("The account email")}</label>
            <input type={kaFjalekalim ? "password" : "email"} value={sekreti}
              onChange={(e) => setSekreti(e.target.value)} style={F.input}
              placeholder={kaFjalekalim ? "••••••••" : email} />
            <p style={F.vogel}>
              {kaFjalekalim
                ? t("We ask once more so that nobody can delete your account from an unlocked phone.")
                : t("You signed in with Google or Apple, so there is no password — type the email exactly.")}
            </p>

            {mesazhi && <div style={F.gabimi}>{mesazhi}</div>}

            <button onClick={fshij} disabled={!gati}
              style={{ ...F.butoniKuq, opacity: gati ? 1 : 0.45, cursor: gati ? "pointer" : "not-allowed" }}>
              {busy ? t("Deleting…") : t("Delete permanently")}
            </button>
          </>
        )}
      </div>

      {/* Rishikuesi i dyqanit nuk di shqip. Pa këtë, faqja është e saktë dhe e
          padobishme njëkohësisht.
          4 shtator 2026 — tani vetë faqja përkthehet, ndaj kjo përmbledhje
          fshihet kur gjuha ËSHTË anglisht: përndryshe e njëjta gjë lexohet dy
          herë, dhe një faqe ligjore që përsërit veten ngjall dyshim, jo besim. */}
      {!anglisht && (
      <div style={F.anglisht}>
        <h2 style={{ ...F.h2, marginTop: 0 }}>Account deletion — summary in English</h2>
        <p><b>App:</b> Pema e Familjes (com.pemaefamiljes.app)</p>
        <p><b>To delete your account:</b> sign in on this page and complete the form above,
          or open the app and go to <i>My profile → Delete my account</i>.
          If you cannot sign in, email <a href={`mailto:${KONTAKTI}`} style={F.lidhja}>{KONTAKTI}</a> from
          your account address; requests are completed within 30 days.</p>
        <p><b>Deleted permanently:</b> your sign-in credentials and linked identity providers,
          your personal contact details, your legacy messages, and your notification settings.</p>
        <p><b>Retained:</b> your entry in the family tree (name, dates, relationships).
          A family tree is shared data — that entry is simultaneously part of other
          relatives' family history, so removing it is a request made to the family
          administrator, not an automatic consequence of closing an account.
          After deletion nobody can sign in as you.</p>
        <p><b>Retention period:</b> account data is removed immediately. Audit records
          required for security are kept as described in the <a href="/privacy" style={F.lidhja}>Privacy Policy</a>.</p>
      </div>
      )}

      <p style={F.fund}>
        <a href="/privacy" style={F.lidhja}>{t("Privacy Policy")}</a> · <a href="/terms" style={F.lidhja}>{t("Terms of Use")}</a>
      </p>
    </div>
  );
}

function Seksioni({ titulli, children }) {
  return (
    <div style={{ marginBottom: 22 }}>
      <h2 style={F.h2}>{titulli}</h2>
      <p style={{ fontSize: 14.5, color: "#444", lineHeight: 1.7, margin: 0 }}>{children}</p>
    </div>
  );
}

const F = {
  faqja: { maxWidth: 720, margin: "0 auto", padding: "40px 20px 60px", fontFamily: "system-ui, sans-serif", color: "#222", lineHeight: 1.7 },
  titulli: { fontSize: 26, marginBottom: 2 },
  nen: { color: "#777", fontSize: 13, marginBottom: 30, marginTop: 0 },
  h2: { fontSize: 16.5, fontWeight: 600, marginBottom: 6, marginTop: 22 },
  gri: { fontSize: 14, color: "#666", margin: "0 0 12px" },
  vogel: { fontSize: 12.5, color: "#777", margin: "6px 0 0" },
  lidhja: { color: "#8A6A1F" },
  kutia: { border: "1px solid #E3DED0", borderRadius: 10, padding: "18px 20px", margin: "28px 0", background: "#FCFBF7" },
  etiketa: { display: "block", fontSize: 12.5, color: "#666", marginTop: 14, marginBottom: 4 },
  input: { width: "100%", boxSizing: "border-box", padding: "10px 12px", fontSize: 15, border: "1px solid #D8D2C2", borderRadius: 7, background: "#fff", color: "#222" },
  paralajmerimi: { background: "#A3331A", color: "#fff", borderRadius: 7, padding: "12px 14px", fontSize: 13.5, lineHeight: 1.5, margin: "10px 0 4px" },
  gabimi: { background: "#FDECEA", border: "1px solid #F0BFB8", color: "#8A2A1C", borderRadius: 7, padding: "10px 12px", fontSize: 13.5, marginTop: 12 },
  butoniKuq: { width: "100%", marginTop: 18, padding: "12px 16px", fontSize: 15, fontWeight: 600, color: "#fff", background: "#A33", border: "none", borderRadius: 8 },
  butoniGri: { display: "inline-block", marginTop: 6, padding: "10px 16px", fontSize: 14.5, color: "#222", background: "#F1EDE2", border: "1px solid #DFD8C6", borderRadius: 8, textDecoration: "none" },
  anglisht: { borderTop: "1px solid #E7E2D6", marginTop: 34, paddingTop: 20, fontSize: 13.5, color: "#555", lineHeight: 1.65 },
  fund: { marginTop: 30, fontSize: 13, color: "#888" },
};
